import { render } from "./ResidenceStep.vue?vue&type=template&id=944e6302&ts=true"
import script from "./ResidenceStep.vue?vue&type=script&lang=ts"
export * from "./ResidenceStep.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/tawa.digital.dashboard/tawa.digital.dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__